export default function Instructor() {
  return (
    <section id="instructor" className="bg-white py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Header */}
        <div className="flex justify-center mb-8">
          <img 
            src="https://kajabi-storefronts-production.kajabi-cdn.com/kajabi-storefronts-production/file-uploads/themes/2160880265/settings_images/aa73b-d423-ef26-5424-f574e4638d4_c821fd2-60ad-dfbb-b7b-3c7076dbb748_0a9554db-dfc8-42b5-bbf2-fe0e7fe8eafe.webp" 
            alt="Icon" 
            className="h-16"
          />
        </div>

        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900">Meet Your Instructor</h2>
        </div>

        {/* Instructor Image */}
        <div className="max-w-5xl mx-auto mb-12">
          <img 
            src="https://static.readdy.ai/image/1ee33a74a7d817227244af36e3fd2b0e/6ba2ebea9227b4beafdb43d1d5ac5a3e.jpeg" 
            alt="Anthony Gallo" 
            className="w-full rounded-lg"
          />
        </div>

        {/* Bio */}
        <div className="max-w-5xl mx-auto space-y-4 text-base text-gray-700 leading-relaxed">
          <p>My name is Serge, and I've spent the last 15 years turning ideas into videos, and videos into a full-time career — all without fancy gear or a film degree.</p>
          
          <p>In high school, I made videos for fun.</p>
          
          <p>In college, while studying to become a doctor, I decided to chase my dreams instead, and turned my passion for content into a freelance business — working with brands around the world (a company I still run today).</p>
          
          <p>In 2023, I co-founded this online course.</p>
          
          <p><span>That course now has 5,000 students from around the globe.</span></p>
          
          <p><span>Throughout the process I started a youtube channel &amp; social media accounts.</span></p>
          
          <p><span>Within the first year of posting content, our Instagram channels hit over 80,000 subscribers and across all channels, </span><span>we have millions of views focused on one topic:</span></p>
          
          <p><strong>Providing Content Creators around the world with the best education &amp; tools to help them achieve their goals.</strong></p>
          
          <p><span>Over the past year, the #1 question I get asked is...</span></p>
          
          <p><span><strong>"Will AI replace content creators as we know it?"</strong></span></p>
          
          <p><span>And here's the truth:</span></p>
          
          <p><span>AI won't replace creators — but creators who </span><span><em>leverage</em></span><span> AI will absolutely replace the ones who don't.</span></p>
          
          <p><span>AI isn't just hype. It's not a gimmick. It's one of the most powerful shifts we've ever seen in content creation — and it's already changing the game for those who know how to use it.</span></p>
          
          <p><span>With the right tools and the right strategy, AI gives creators a massive advantage:</span></p>
          
          <ul className="list-disc pl-6 space-y-2">
            <li><span>You can focus on the parts you love.</span></li>
            <li><span>Outsource the parts you hate.</span></li>
            <li><span>Create better content, faster.</span></li>
            <li><span>Avoid burnout.</span></li>
            <li><span>And unlock a level of creativity that's hard to imagine until you've experienced it yourself.</span></li>
          </ul>
          
          <p><span>But here's the catch...</span></p>
          
          <p><span>Most tutorials online are outdated or way too generic. They show you what a tool </span><span><em>does</em></span><span> — but not how to actually </span><span><em>use</em></span><span> it to create viral videos, grow your audience, or scale your business.</span></p>
          
          <p><span>When AI first started blowing up, I thought it was a gimmick. A shortcut that would just get in the way of learning real skills.</span></p>
          
          <p><span>And at the time... I wasn't wrong.</span></p>
          
          <p><span>Two years ago, AI wasn't quite there yet. The tools were interesting — but clunky, inconsistent, and not all that helpful for creators.</span></p>
          
          <p><span>Still, I kept watching. Because deep down, I knew what was coming.</span></p>
          
          <p><span>And sure enough, the pace of progress was INSANE. Within months, the tools got smarter. The outputs got better. And suddenly, it hit me:</span></p>
        </div>

        <div className="max-w-5xl mx-auto my-12">
          <h3 className="text-3xl font-bold text-gray-900 text-center">
            <span><strong>AI will become the most valuable tool in a creator's toolkit.</strong></span>
          </h3>
        </div>

        <div className="max-w-5xl mx-auto space-y-4 text-base text-gray-700 leading-relaxed">
          <p><span>So I dove in.</span></p>
          
          <p><span>I spent months testing every AI tool I could get my hands on. I wasted time. I wasted money. I burned through bad advice and outdated tutorials.</span></p>
          
          <p><span>But eventually, I cracked the code.</span></p>
          
          <p><span>Now?</span></p>
          
          <ul className="list-disc pl-6 space-y-2">
            <li><span>We create 3–4x faster.</span></li>
            <li><span>Our videos look better.</span></li>
            <li><span>They sound better.</span></li>
            <li><span>They perform better.</span></li>
            <li><span>And we're having </span><span><em>way more fun</em></span><span> making content again.</span></li>
          </ul>
          
          <p><span>If you've ever wondered how your favorite creators crank out high-quality content so consistently — this is the secret.</span></p>
          
          <p><span>And now, I want to share it with you.</span></p>
        </div>
      </div>
    </section>
  );
}
